var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('core-toolbar'),(_vm.authenticated)?_c('core-drawer'):_vm._e(),_c('core-view'),_c('core-snack-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }